import { z } from "zod";

export const DeviceStatusChangeSchema = z.object({
  id: z.number().int().optional(),
  device_id: z.string().trim().min(1),
  action: z.string().trim().min(1),
  changed_at: z.string(),
  changed_by: z.string().trim().min(1),
});

export type DeviceStatusChange = z.infer<typeof DeviceStatusChangeSchema>;
